import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from "@angular/core";;

declare var $: any;
declare var jQuary: any;

import * as videojs from 'video.js';
import 'videojs-contrib-hls';
import 'videojs-flash';
import { BackendApiService } from "../shared/services/backend-api.service";
import { MatSnackBar } from "@angular/material";
import { environment } from "../../environments/environment.prod";
@Component({
  selector: "app-video-js",
  templateUrl: "./video-js.component.html",
  styleUrls: ["./video-js.component.css"]
})
export class VideoJsComponent implements OnInit, OnDestroy {
  @ViewChild('video') private videojsElement: ElementRef;
  player: any;

  constructor(
    private backendApiService: BackendApiService,
    private snackBar: MatSnackBar,
  ) {

  }
  ngOnDestroy() {
    // this.player.dispose();
  }

  ngOnInit() {


  }
  ngAfterViewInit() {
    this.backendApiService.getData().subscribe(response => {
      if (response.mediaDetails) {
        if (response.mediaDetails['Home Channel']) {
          if (response.mediaDetails['Home Channel'][0]) {
            const options = {
              "width": "100%",
              "techOrder": ["html5"],
            };
            this.player = videojs(
              this.videojsElement.nativeElement, options, function onPlayerReady() {
                videojs.log('Your player is ready!');
                this.play();
              });
            this.player.src([{
              type: 'application/x-mpegURL',
              src: response.mediaDetails['Home Channel'][0].mediaUrl,
              label: true
            }]);
          }
        }
      }    },        error => {
        this.snackBar.open(
          new DOMParser()
            .parseFromString(error.error, 'text/html')
            .getElementsByTagName('p')[1].textContent.replace('Message', ''),
          '',
          {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            direction: 'ltr'
          }
        );
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/video-js/video-js.component.ts